import Dialog from './Dialog';
import common from '../common';
import Character from '../Character';
import Text from './Text';
import i18next from 'i18next';

export default class AchievementsPanel extends Dialog {
	constructor() {
		super(950, 550, null);

		this._buttons = null;
		this._activeButton = null;
		this._activeButtonState = null;
		this.timerClock = null;
		this.timerEnd = null;
		this.timeStart = null;
		this._picture = null;
		this._fade = null;
		this._achievementIndex = 0;

		this._objectives = {
			housing: null,
			school: null,
			hospital: null,
			mission: null,
		};

		this._opened = [];
		this.signals = {};
		this.signals.unlocked = new P3.utils.MiniSignal();
		this.signals.opened = new P3.utils.MiniSignal();

		this._strings = { // We need one of these for every scenario. And gotta rework it to change with difficulty.
			SCHOOL: common.scenario.targets.school > 1 ? i18next.t('gui.general.schools') : i18next.t('structure.school.description'),
			HOSPITAL: common.scenario.targets.hospital > 1 ? i18next.t('gui.general.hospitals') : i18next.t('structure.hospital.description'),
		};

		this._languageChangeSignal = common.languageManager.signals.changed.add(this.onLanguageChange, this);

		this.init();
	}

	init() {
		this._fade = new PIXI.Graphics();
		this._fade.beginFill(0x0, 0.5);
		this._fade.drawRect(0, 0, P3.View.width, P3.View.height);
		this._fade.endFill();
		this._fade.position.set((common.STAGE_WIDTH - P3.View.width) * 0.5, this._fade.height * 0.5);
		this.addChildAt(this._fade, 0);

		delete this._panel.body.text;

		this._buttons = [];

		this.setTitleText('gui.general.keyfacts');

		this._panel.body.top = this._createTopSection(common.achievements.achievements.length);
		this._panel.body.addChild(this._panel.body.top);

		this._panel.body.achievements = this._createAchievementBody();
		this._panel.body.achievements.visible = false;
		this._panel.body.addChild(this._panel.body.achievements);

		this.checkAchievements();

		this._panel.body.top.position.set(
			(this._panel.body.width - this._panel.body.top.width) * 0.5 + 25,
			(this._panel.body.height - 90),
		);
	}

	_createPageButtons() {
		let states = new P3.ButtonStates();

		states.normal = P3.assets.texture('btn_black_outline_9slice_out');
		states.over = P3.assets.texture('btn_black_outline_9slice_over');
		states.icon = P3.assets.texture('icon_arrow_r');

		this._prevPageButton = common.buttonFactory.createButton(states);
		this._prevPageButton.visible = false;
		this._prevPageButton.tint = 0x33415e;
		this._prevPageButton.scale.x = -1;
		this._prevPageButton.position.set(100, this._panel.height - this._prevPageButton.height - 20);
		this._prevPageButton.signals.click.add(this._onPrevButtonClick, this);
		this._panel.body.addChild(this._prevPageButton);

		this._prevPageButton.accessibleTitle = i18next.t('accessibility.button.previous');

		states = new P3.ButtonStates();
		states.normal = P3.assets.texture('btn_blue_fill_medium_9slice_out');
		states.over = P3.assets.texture('btn_blue_fill_medium_9slice_over');
		states.icon = P3.assets.texture('icon_arrow_r');

		this._nextPageButton = common.buttonFactory.createButton(states);
		this._nextPageButton.position.set(this._panel.width - this._nextPageButton.width - 10, this._panel.height - this._nextPageButton.height - 20);
		this._nextPageButton.signals.click.add(this._onNextButtonClick, this);
		this._panel.body.addChild(this._nextPageButton);

		this._nextPageButton.accessibleTitle = i18next.t('accessibility.button.next');
	}

	checkAchievements() {
		for (const i in common.achievements.achievements) {
			if (common.achievements.achievements[i] === true) {
				this.setNew(parseInt(i));
			}
		}
	}

	onCloseButtonClick() {
		this.visible = false;
	}

	_createTopSection(count) {
		const section = new PIXI.Container();

		for (let i = 0; i < count; i++) {
			const icon = new PIXI.Sprite(P3.assets.texture('btn_key_fact_off_out'));

			icon.anchor.set(0.5);
			icon.position.set(((950) / count) * i, 0);
			icon.interactive = false;
			icon.buttonMode = true;

			icon.label = new Text((i + 1).toString(), { font: '32px', fontWeight: 'bold', align: 'left', tint: 0x0 });
			icon.label.anchor.set(0.5);
			icon.label.position.set(0, 0);
			icon.addChild(icon.label);

			icon.newPip = new PIXI.Sprite(P3.assets.texture('btn_key_fact_new_out'));
			icon.newPip.anchor.set(0.5);
			icon.newPip.visible = false;
			icon.newPip.position.set(icon.width * 0.5 - 10, icon.height * -0.5);
			icon.addChild(icon.newPip);

			icon.index = i;
			icon.on('pointertap', () => {
				this._onAchievementButtonClick(icon);
			});
			icon.new = false;

			section.addChild(icon);
			this._buttons.push(icon);
		}

		return section;
	}

	_createAchievementBody() {
		const section = new PIXI.Container();

		section.y = 90;

		const avatar = new PIXI.Container();

		avatar.position.set(45, 30);
		section.addChild(avatar);

		avatar.bg = new PIXI.Sprite(P3.assets.texture('character_bg'));
		avatar.bg.anchor.set(0);
		avatar.addChild(avatar.bg);

		avatar.fg = new PIXI.Sprite(P3.assets.texture('character_fg'));
		avatar.fg.anchor.set(0);
		avatar.addChild(avatar.fg);

		this._picture = new Character();
		this._picture.view.scale.set(0.5);
		this._picture.position.set(avatar.bg.width * 0.5, avatar.bg.height);
		avatar.addChild(this._picture);

		avatar.circleMask = new PIXI.Graphics();
		avatar.circleMask.position.set(avatar.bg.width * 0.5, avatar.bg.height * 0.5);
		avatar.circleMask.beginFill(0x0);
		avatar.circleMask.drawCircle(0, 0, 74);
		avatar.circleMask.endFill();
		avatar.addChild(avatar.circleMask);
		avatar.mask = avatar.circleMask;

		section.title = new Text('...', { font: '32px', fontWeight: 'bold', align: 'left', tint: 0x0 });
		section.title.anchor.set(0);
		section.title.position.set(avatar.x + avatar.width + 25, 37);
		section.addChild(section.title);

		section.content = new Text('...', { font: '26px', align: 'left', tint: 0x0, maxWidth: 950 - (avatar.x - avatar.width) - 350 });
		section.content.anchor.set(0);
		section.content.position.set(avatar.x + avatar.width + 25, 70);
		section.addChild(section.content);

		return section;
	}

	onLanguageChange() {
		this._strings.SCHOOL = common.scenario.targets.school > 1 ? i18next.t('gui.general.schools') : i18next.t('structure.school.description');
		this._strings.HOSPITAL = common.scenario.targets.hospital > 1 ? i18next.t('gui.general.hospitals') : i18next.t('structure.hospital.description');

		/* this._objectives.housing.value.text = i18next.t('gui.overviewpanel.goals.housing.value', {...this._strings, NUMBER: common.scenario.targets['housing']});
		this._objectives.school.value.text = i18next.t('gui.overviewpanel.goals.school.value', {...this._strings, NUMBER: common.scenario.targets['school']});
		this._objectives.hospital.value.text = i18next.t('gui.overviewpanel.goals.hospital.value', {...this._strings, NUMBER: common.scenario.targets['hospital']});
		this._objectives.mission.value.text = i18next.t('gui.overviewpanel.goals.hotel.value', {...this._strings, NUMBER: common.scenario.targets['mission']});
 */
		this._panel.body.achievements.title.text = `${i18next.t('gui.general.fact')} ${this._achievementIndex}`;
		this._panel.body.achievements.content.text = i18next.t(`${common.selectedLevel}.keyfacts.fact${this._achievementIndex}`);
	}

	displaySeconds(time) {
		// const h = P3.utils.padNum(Math.floor((time / 60) / 60), 2);
		const m = P3.utils.padNum(Math.floor(time / 60), 2);
		const s = P3.utils.padNum(Math.floor(time % 60), 2);

		return `${m}:${s}`;
	}

	update() {
		this._picture.update();
	}

	resize() {
		if (this._fade) {
			this._fade.position.set(P3.View.width * -0.5, this._fade.height * -0.5);
			this._fade.width = P3.View.width;
			this._fade.height = P3.View.height;
		}
	}

	toggleObjective(which, state) {
		if (state) {
			this._objectives[which].icon.texture = this._objectives[which].iconOn;
			this._objectives[which].value.tint = this._objectives[which].valueOn;
		} else {
			this._objectives[which].icon.texture = this._objectives[which].iconOff;
			this._objectives[which].value.tint = this._objectives[which].valueOff;
		}
	}

	_onAchievementButtonClick(button) {
		this._achievementIndex = button.index;
		this._showAchievement(button.index);
		this.setActive(button.index);
		this._opened.push(button.index);
	}

	appear() {
		this.parent.addChild(this); // set to top

		const firstUnlocked = this.firstUnlocked;

		this.checkAchievements();
		this.scale.set(0.8);
		this._fade.visible = true;

		this._onAchievementButtonClick(firstUnlocked);

		this._panel.body.achievements.visible = true;
		this.visible = true;

		new TWEEN.Tween(this.scale, this.tweens)
			.to({
				x: 1,
				y: 1,
			}, 300)
			.easing(TWEEN.Easing.Back.Out)
			.start();
	}

	destroy() {
		common.languageManager.signals.changed.detach(this._languageChangeSignal, this);

		super.destroy();
	}

	_showAchievement(which) {
		this._panel.body.achievements.visible = true;
		this._panel.body.achievements.title.text = `${i18next.t('gui.general.fact')} ${which + 1}`;
		this._panel.body.achievements.content.text = i18next.t(`${common.selectedLevel}.keyfacts.fact${which + 1}`);
		this._picture.playAnimation('talking');
		P3.utils.delay(5, () => {
			this._picture.playAnimation('happy');
		}, this);
	}

	setActive(index) {
		if (this._activeButton) {
			this._activeButton.texture = this._activeButtonState;
			this._activeButton.label.style.tint = 0x0;
		}

		if (this._buttons[index].new === true) {
			this._activeButtonState = P3.assets.texture('btn_key_fact_on_out');
			this._buttons[index].new = false;
			this._buttons[index].newPip.visible = false;
		} else {
			this._activeButtonState = this._buttons[index].texture;
		}

		this._buttons[index].texture = P3.assets.texture('btn_key_fact_active_out');
		this._buttons[index].label.style.tint = 0xFFFFFF;

		this._activeButton = this._buttons[index];
		this.signals.opened.dispatch();
	}

	setInactive(index) {
		this._buttons[index].texture = P3.assets.texture('btn_key_fact_off_out');
	}

	setUnlocked(index) {
		this._buttons[index].interactive = true;
		this._buttons[index].texture = P3.assets.texture('btn_key_fact_on_out');
		this._buttons[index].label.tint = 0xFFFFFF;

		this.signals.unlocked.dispatch();
	}

	setNew(index) {
		if (this._opened.includes(index)) {
			return;
		}

		this._buttons[index].interactive = true;
		this._buttons[index].new = true;
		this._buttons[index].newPip.visible = true;
		this._buttons[index].texture = P3.assets.texture('btn_key_fact_on_out');
	}

	_onPrevButtonClick() {
		this._nextPageButton.visible = true;
	}

	_onNextButtonClick() {
		this._prevPageButton.visible = true;
	}

	get new() {
		const newAchievements = [];

		for (const button of this._buttons) {
			if (button.new) {
				newAchievements.push(button);
			}
		}

		return newAchievements;
	}

	get firstUnlocked() {
		for (const button of this._buttons) {
			if (button.interactive) {
				return button;
			}
		}

		return null;
	}

	get extended() {
		return this._extended;
	}

	get parentButton() {
		return this._parentButton;
	}

	get opened() {
		return this._opened;
	}
}
